import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ORGANIZATION_STATUSES } from "@/api/types";
import { StoresPage } from "@/features/stores/stores-page";
import { baseListSearch, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/stores/")({
  validateSearch: z.object({ ...baseListSearch, organizationId: optionalString, status: optionalEnum(ORGANIZATION_STATUSES), brand: optionalString }),
  head: () => ({ meta: [{ title: "Stores · Rogue Admin" }] }),
  component: StoresPage,
});
